module.exports = __webpack_public_path__ + "static/media/tg.67ab4d30.png";